import React from 'react';

const ArrowUp = ({ color = '#7F7182' }) => (
  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.99971 0.425097C6.13304 0.425097 6.25804 0.44593 6.37471 0.487597C6.49137 0.529264 6.59971 0.600097 6.69971 0.700097L11.2997 5.3001C11.483 5.48343 11.5747 5.71676 11.5747 6.0001C11.5747 6.28343 11.483 6.51676 11.2997 6.7001C11.1164 6.88343 10.883 6.9751 10.5997 6.9751C10.3164 6.9751 10.083 6.88343 9.89971 6.7001L5.99971 2.8001L2.09971 6.7001C1.91637 6.88343 1.68304 6.9751 1.39971 6.9751C1.11637 6.9751 0.88304 6.88343 0.699707 6.7001C0.516374 6.51676 0.424707 6.28343 0.424707 6.0001C0.424707 5.71676 0.516374 5.48343 0.699707 5.3001L5.29971 0.700097C5.39971 0.600097 5.50804 0.529263 5.62471 0.487597C5.74137 0.44593 5.86637 0.425097 5.99971 0.425097Z"
      fill={color}
    />
  </svg>
);

export default ArrowUp;
